import { makeStyles } from '@material-ui/styles';
import { ITheme } from '../../../style/theme';

export const useStyles = makeStyles((theme: ITheme) => ({
  table: {
    paddingTop: 16,
    display: 'table',
    width: '100%',
    height: '100%',
  },
  tableHeadRow: {
    display: 'table-row',
  },
  tableRow: {
    display: 'table-row',
  },
  tableHeadCell: {
    display: 'table-cell',
    verticalAlign: 'middle',
    padding: theme.spacing(1.5),
  },
  tableCell: {
    display: 'table-cell',
    verticalAlign: 'middle',
    padding: theme.spacing(1.5),
  },
  tableHeadValue: {
    textTransform: 'uppercase',
  },
  columnValue: {
    placeContent: 'center',
  },
  boldValue: {
    fontWeight: 'bold',
  },
}));
